/* (ignored) */


//////////////////
// WEBPACK FOOTER
// fs (ignored)
// module id = 12
// module chunks = 1